import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import About from "@/pages/about/page";
import Category from "@/pages/category/page";
import CategorySlug from "@/pages/category/[slug]/page";
import Article from "@/pages/article/[slug]/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/category",
    element: <Category />,
  },
  {
    path: "/category/:slug",
    element: <CategorySlug />,
  },
  {
    path: "/article/:slug",
    element: <Article />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;